const initialState = ({
  ...process.env || {},
  ...window.AppENV || {},
  appConf: window.appConf || {}
});

function serviceConfig(state = initialState) {
  // static configs
  return state;
}

export default serviceConfig;
